import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Card, Col } from 'react-bootstrap'
import { _Lowering_ } from '../vocab'

class SubStatusCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current_time: moment.utc(),
      elapse_time: moment.utc(0),
      warning_threshold: moment.utc(0).set('minute', 15),
      timer: null
    }

    this.updateClocks = this.updateClocks.bind(this)
  }

  componentDidMount() {
    this.setState({ timer: setInterval(this.updateClocks, 1000) })
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  updateClocks() {
    const current_time = moment.utc()
    const elapse_time =
      this.props.last_update && this.props.active_lowering.lowering_id
        ? moment.utc(moment().diff(this.props.last_update, current_time))
        : moment.utc(0)
    this.setState({ current_time, elapse_time })
  }

  render() {
    const elapse_time_style = this.state.elapse_time.diff(this.state.warning_threshold) > 0 ? 'text-warning' : ''

    return (
      <Col className='event-data-col ms-auto' sm={this.props.sm || 6} md={this.props.md || 4} lg={this.props.lg || 3}>
        <Card className='sub-status-card'>
          <Card.Body>
            <div>
              {_Lowering_}: <span className='float-right'>{this.props.active_lowering ? this.props.active_lowering.lowering_id : ''}</span>
            </div>
            <div>
              Time (UTC): <span className='float-right'>{this.state.current_time.format('HH:mm:ss')}</span>
            </div>
            <div>
              Elapse: <span className={`float-right ${elapse_time_style}`}>{this.state.elapse_time.format('HH:mm:ss')}</span>
            </div>
          </Card.Body>
        </Card>
      </Col>
    )
  }
}

SubStatusCard.propTypes = {
  active_lowering: PropTypes.object,
  last_update: PropTypes.string,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number
}

export default SubStatusCard
